import React, { useState } from "react";
import { Info } from "lucide-react";

const CustomeInfoTooltip = ({ description, showIcon = true, children }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div
            style={{ position: "relative", display: "inline-block" }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            {showIcon ? <Info size={16} color="#9CA3AF" style={{ cursor: "pointer" }} /> : children}

            {showTooltip && (
                <div
                    style={{
                        width: "200px", // Fixed width
                        position: "absolute",
                        top: showIcon ? "0%" : "120%",
                        left: showIcon ? "150%" : "80%",
                        // transform: showIcon ? undefined : "translateX(-100%)",
                        background: "#0d1f3c",
                        color: "#FFFFFF",
                        padding: "12px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        lineHeight: "20px",
                        whiteSpace: "pre-line",
                        wordWrap: "break-word",
                        fontFamily: "Plus Jakarta Sans",
                        fontWeight: "400",
                        zIndex: 100,
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)"
                    }}
                >
                    {description}
                    {/* Arrow Pointer */}
                    <div
                        style={{
                            position: "absolute",
                            top: showIcon ? "16px" : "-6px",  // Push arrow upwards to tooltip top
                            left: showIcon ? "-6px" : "16px", // Arrow will be at top-left corner
                            transform: "rotate(45deg)",
                            width: "12px",
                            height: "12px",
                            background: "#0D1F3C",
                            zIndex: -1,
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default CustomeInfoTooltip;